import apiClient from "./apiClient";

const BASE = "/api/Doctor";

// API returns doctorID (no `id`) — alias it so list/edit/filter code using `.id` works.
const withId = (d) => ({ ...d, id: d.doctorID });

export const getDoctors = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const getDoctor = async (id) => {
  const res = await apiClient.get(`${BASE}/${id}`);
  return { ...res, data: withId(res.data) };
};
export const createDoctor = (data) => apiClient.post(`${BASE}/save`, data);
export const updateDoctor = (id, data) => apiClient.post(`${BASE}/save`, { ...data, doctorID: id });
export const deleteDoctor = (id) => apiClient.delete(`${BASE}/${id}`);
